"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToCache = addToCache;
exports.clearCache = clearCache;
exports.getState = exports["default"] = void 0;
exports.initCache = initCache;
exports.initialState = void 0;
exports.removeFromCache = removeFromCache;
exports.replaceCache = replaceCache;
exports.subscribe = exports.store = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _redux = require("redux");
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// React Hooks: How to create and update Context.Provider
// https://dev.to/oieduardorabelo/react-hooks-how-to-create-and-update-contextprovider-1f68

// Getting Started with Redux
// https://redux.js.org/introduction/getting-started

// import * as stubs from './stubbing'

// Actions Types
var INIT = 'INIT';
var ADD = 'ADD';
var REPLACE = 'REPLACE';
var REMOVE = 'REMOVE';
var CLEAR = 'CLEAR';

// Initial State
var initialState = exports.initialState = {
  loading: true,
  language: 'en',
  balances: {
    text: {
      quantity: 0,
      startingQuantity: 0
    },
    data: {
      quantity: 0,
      startingQuantity: 0
    },
    voice: {
      quantity: 0,
      startingQuantity: 0
    }
  },
  provisionedOneOffAddOns: [],
  provisionedRecurringAddOns: []
};

// Reducer
function cacheReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ADD:
      return _objectSpread(_objectSpread({}, state), action.payload);
    case REMOVE:
      {
        var _action$payload = action.payload,
          _omitted = state[_action$payload],
          rest = (0, _objectWithoutProperties2["default"])(state, [_action$payload].map(_toPropertyKey));
        return rest;
      }
    case REPLACE:
      return action.payload;
    case CLEAR:
      return initialState;
    default:
      return state;
  }
}

// Store { subscribe, dispatch, getState }
var store = exports.store = (0, _redux.createStore)(cacheReducer);
// export const store = process.env.NODE_ENV === "development"
//   ? createStore(cacheReducer, applyMiddleware(require('redux-logger').default))
//   : createStore(cacheReducer)

// Actions
function initCache(object) {
  store.dispatch({
    type: INIT,
    payload: object
  });
}
function addToCache(object) {
  store.dispatch({
    type: ADD,
    payload: object
  });
}
function removeFromCache(key) {
  store.dispatch({
    type: REMOVE,
    payload: key
  });
}
function replaceCache(object) {
  store.dispatch({
    type: REPLACE,
    payload: object
  });
}
function clearCache() {
  store.dispatch({
    type: CLEAR
  });
}
var subscribe = exports.subscribe = store.subscribe;
var getState = exports.getState = store.getState;
var _default = exports["default"] = store; // For debugging in development mode
if (process.env.NODE_ENV === "development") {
  if (window) window.store = store;
}